import cn from 'classnames';
import styles from './PageTitle.module.scss';
import { ReactNode } from 'react';

type PageTitleProps = {
  text: string;
  icon?: ReactNode;
  info?: ReactNode;
  className?: string;
};

export function PageTitle({ text, icon, info, className }: PageTitleProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <h1 className={styles.title}>
        {text}
        {icon}
      </h1>
      {info}
    </div>
  );
}
